import http from '../utils/http';

export default {
    getAll() {
        return http.get({
            url: '/py/storage/v1?page=0&size=200'
        });
    }
};
